import { useEffect } from 'react'
import useEP from './useEP'
import { getTreeData } from '../services/services'

const useTreeData = ({ personId }) => {
  const [state, dispatch, fn] = useEP(getTreeData)

  useEffect(() => {
    if (personId) {
      dispatch({ type: 'load' })
    }
  }, [dispatch, personId])

  useEffect(() => {
    if (state.load) {
      getTreeData({ personId }).then((res) => {
        dispatch({ type: 'complete', res })
      })
    }
  }, [dispatch, personId, state.load])

  return [state, dispatch, fn]
}
export default useTreeData
